import { Outlet, useNavigate } from "react-router-dom";
import "./css/MainLayout.scss";
import Sidebar from "../sidebar/Sidebar";
import { useEffect, useState } from "react";
import fetchProfile from "../../../api/userProfile";
import { ReactComponent as User } from "../../../assets/images/user.svg";
import LoginPage from "../login/LoginPage";
import logo from "../../../assets/images/adddlogo.png";

const MainLayout = () => {
  const [profile, setProfile] = useState<any>(null);
  const [token, setToken] = useState<string>(() => sessionStorage.getItem("token") || "");
  const navigate = useNavigate();

  useEffect(() => {
    const storedToken = sessionStorage.getItem("token");
    if (storedToken) {
      setToken(storedToken);
      fetchProfileData();
    } else {
      navigate("/");
      window.location.reload();
    }
  }, [navigate]);

  const fetchProfileData = async () => {
    try {
      const profileData = await fetchProfile();
      setProfile(profileData);
    } catch (error) {
      console.error('프로필 데이터를 불러오는 중 오류 발생:', error);
    }
  };

  const handleLogout = async () => {
    try {
      const refreshToken = sessionStorage.getItem("token");
      const response = await fetch(`${process.env.REACT_APP_URL}/auth/logout`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `${refreshToken}`
        },
      });
      if (response.ok) {
        sessionStorage.removeItem("token");
        navigate("/");
        window.location.reload();
      } else {
        console.error("로그아웃 실패");
      }
    } catch (error) {
      console.error("로그아웃 요청 중 오류 발생", error);
    }
  };

  return (
    <div className="app-shell">
      {token ? (
        <>
          <header className="top-section">
            <div className="brand-lockup">
              <img src={logo} alt="addd" />
              <span className="brand-lockup__divider" />
              <div>
                <strong>AI DATA</strong>
                <span>OPERATIONS CONSOLE</span>
              </div>
            </div>
            {profile?.data?.name && (
              <div className="profile-container">
                <div className="profile-info">
                  <span className="profile-icon">
                    <User />
                  </span>
                  <span className="profile-copy">
                    <small>SIGNED IN</small>
                    <strong className="profile-name">{profile.data.name}</strong>
                  </span>
                </div>
                <button className="logout-button" onClick={handleLogout}>로그아웃</button>
              </div>
            )}
          </header>
          <main className="main-shell">
            <Sidebar />
            <div id="mainDiv">
              <div className="main-content">
                <Outlet />
              </div>
            </div>
          </main>
        </>
      ) : (
        <LoginPage />
      )}
    </div>
  );
};

export default MainLayout;
